module.exports = __webpack_public_path__ + "static/media/graphic-2.1c7df3c2.png";